export default {
      id: "unit_dashboard__check_danger-usage",
      viewBox: "0 0 19 18",
      url: __webpack_public_path__ + "img/icons.svg#unit_dashboard__check_danger",
      toString: function () {
        return this.url;
      }
    }